import useHehmApi from 'hooks/useHehmApi'

import HehmDevice from 'types/HehmDevice'

const useHehmDevice = (deviceId: string) => {
  const path = `/devices/${deviceId}`

  const {
    hehmData,
    isHehmDataLoaded: isHehmDeviceLoaded
  } = useHehmApi(path)

  const hehmDevice = hehmData as HehmDevice

  return {
    hehmDevice,
    isHehmDeviceLoaded
  }
}

export default useHehmDevice
